/* Component Dependencies */
var hotelRewardsPointsTemplate = require('templates/hotelRewardsPoints.hbs');
var AriesComponent = require('libs/aries-component');
var makeSendtoLink = require('utils/makeSendtoLink');
var $ = require('jquery');

AriesComponent.create({
    type: 'hotelRewardsPoints',
    template: {
        'hotelRewardsPoints': hotelRewardsPointsTemplate
    },
    bindEvents: function() {
        var _self = this;
        _self.$el.find('.js-sent-to-link').on('click', _self.sendToLink);
    },

    /**
     * This function builds the full url and opens it in a new window.
     * @param {Object} event Event object of target element
     * @returns {Object} Current component instance
     */
    sendToLink: function _sendToLink(event) {
        event.preventDefault();
        event.stopPropagation();
        var element = $(event.currentTarget),
            options = {};
        options.country = element.data('country');
        options.brand = element.data('brand');
        options.uri = element.attr('href');
        options.popupCode = element.attr('data-popup-code');
        makeSendtoLink.sendto(options.country, options.brand, options.uri, options.popupCode);
        return this;
    }
});
